module.exports = __webpack_public_path__ + "img/Frente-15-00 off.30113866.png";